module.exports = __webpack_public_path__ + "img/Shale-Quote-Background.jpg";